import { DatesModel, datesConfig, datesDictionary } from "..";
import { DatesRetriever, DatesGateway } from "../retriever";
import { BFFGateway,  internalMessageBus } from "sb-resp-lib";
import { datesQueryFactory } from "../queries";
import { DatesParser } from "../parser";
import { Retriever, Clock, MessageSender, MessageBus, State, ToggleTabEvent, ITimeZoneObservable } from "../../../common";
import { GroupedSportsToDatesMapper } from "../mapper";

export const datesRetrieverFactory = (cms: datesConfig, dict: datesDictionary, timeZoneObservable: ITimeZoneObservable) => {
    const clock = new Clock(Date);
    const datesGateway = new DatesGateway(new BFFGateway(), datesQueryFactory, new GroupedSportsToDatesMapper(dict), clock, cms.timeRange);
    const toggleTabEvent = new ToggleTabEvent(new MessageBus(internalMessageBus), cms.blockId);
    return new DatesRetriever(datesGateway, toggleTabEvent, clock, timeZoneObservable, cms.keepSelectedDay);
}

export const datesParserFactory = (cms: datesConfig, retriever: Retriever<DatesModel>) => {
    const messageSender = new MessageSender(new MessageBus(internalMessageBus), cms.blockId);
    return new DatesParser(retriever, messageSender);
}

export const datesStateFactory = (cms: datesConfig) => {
    const messageSender = new MessageSender(new MessageBus(internalMessageBus), cms.blockId);
    return new State<DatesModel>(messageSender, cms.blockId);
}